import React from 'react'
import { useEffect } from 'react'
import { useState } from 'react'
import Images from '../assets/images/Images'
import { getAutoPayStatus, getPaymentMethod, getActiveInstallmentPlan } from '../services/Api'
import Loading from './Loading'
import { enrollAutoPay, updateAutoPay, cancelAutoPay } from '../services/Api'
const AutoPayModal = ({ pol, zip, env, GetPaymentData, managePaymentMethods, sessionID, setIsLoading, updateAutopayCompleted, show, setShow, isAutopay, autopayManagePayMethods, source}) => {
    const [autoPayReady, setAutoPayReady] = useState(false)
    const [isAutopayEnrolled, setIsAutopayEnrolled] = useState(false)
    const [isUpdateAutopayDisabled, setIsUpdateAutopayDisabled] = useState(true)
    const [isEnrollAutopayDisabled, setIsEnrollAutopayDisabled] = useState(true)
    const [payment, setPayment] = useState({})
    const [activeMethod, setActiveMethod] = useState({
        PaymentMethodType: "",
        PaymentMethodId: "",
        ProcessOneToken: "",
        CreditCardType: "",
        PaymentMethodName: "",
        BankName: "",
        BankAccountType: "",
        LastFour: "",
        CardExpirationMonth: "",
        CardExpirationYear: ""
    })
    const [paymentMethods, setPaymentMethods] = useState([{
        PaymentMethodType: "",
        PaymentMethodId: "",
        ProcessOneToken: "",
        CreditCardType: "",
        PaymentMethodName: "",
        BankName: "",
        BankAccountType: "",
        LastFour: "",
        CardExpirationMonth: "",
        CardExpirationYear: ""
    },
    {
        PaymentMethodType: "",
        PaymentMethodId: "",
        ProcessOneToken: "",
        CreditCardType: "",
        PaymentMethodName: "",
        BankName: "",
        BankAccountType: "",
        LastFour: "",
        CardExpirationMonth: "",
        CardExpirationYear: ""
    }])
    const $ = window.$
    var actionType = "";
    useEffect(() => {
        if (show === true) {
            setAutoPayReady(false)
            const init = async () => {
                const payment = await GetPaymentData(pol, zip, env)
    
                setPayment(payment)
                const autopayenrolled = await CheckIsAutopayEnrolled(pol, env)
                const pmethods = await GetPaymentMethods(payment.CustomerID, env)
                if (autopayenrolled) {
                    const activemethodtkn = await GetActiveInstallmentPlan(pol, env)
                    pmethods.map((pmethod) => {
                        if (pmethod.ProcessOneToken === activemethodtkn.InstallmentPlanDetails.InstallmentPlanTokenId) {
                            setActiveMethod(pmethod);
                        }
                    })
                }
                setIsAutopayEnrolled(autopayenrolled);
                setPaymentMethods(pmethods)
                setAutoPayReady(true)
            }
            if (pol.length >= 8 && zip.length === 5 && env !== "" && isAutopay) {
                init()
            }
        }
    }, [pol, zip, env, isAutopay, show])

    const GetPaymentMethods = async (customerid, env) => {
        const getpaymentmethod_resp = await getPaymentMethod(customerid, env)
        return getpaymentmethod_resp.PaymentMethods
    }
    const CheckIsAutopayEnrolled = async (pol, env) => {
        const autopayenrolled_resp = await getAutoPayStatus(pol, env);
        return (autopayenrolled_resp !== "") //resp will be "gw" or "oneinc" if there is an active payment plan
    }
    const GetActiveInstallmentPlan = async (pol, env) => {
        const getactiveinstallmentplan_resp = await getActiveInstallmentPlan(pol, env)
        return getactiveinstallmentplan_resp
    }

    const ShowConfirmation = async (Pol, Zip, Env, Type) => {
            console.log("Enrolling in autopay...")
            // const payment = await GetPaymentData(Pol, Zip, Env)
            const PayMethodTokenId = $('input[name="PaymentMethod"]:checked').val();
            const activeMethod = paymentMethods.filter(x=>x.ProcessOneToken === PayMethodTokenId)[0];
            $("#formDiv").css("display", "none");

            if(activeMethod.PaymentMethodType === "Eft"){
                $("#PaymentMethodRow").html(`<span>${activeMethod.BankName}</span> <span>${activeMethod.BankAccountType} ending in ${activeMethod.LastFour}</span>`);
                $("#PaymentMethodHeader").html(`By selecting "Enroll", you are authorizing CURE Auto Insurance to use the specified account for future payments.`)
                $("#PaymentMethodInfo").html(`* By choosing this account as your payment method, you are authorizing CURE Auto Insurance  to initiate one or more withdrawals from this account for the total payment amount(s) due (including applicable fees), and you authorize the holding financial institution to deduct such payments. You are acknowledging that your provided account will remain on file until you notify CURE Auto Insurance of its termination in such a manner as to afford the banking organization a reasonable opportunity to act on it. You agree that CURE Auto Insurance may reinitiate new debits from the specified account if any debit is returned by your bank (in accordance with the Nacha Rules). You acknowledge that the origination of Automated Clearinghouse (ACH) transactions to your account must comply with the provisions of U.S. law.`)
            }else{
                $("#PaymentMethodRow").html(`<span>Credit Card</span><span>${activeMethod.CreditCardType} ending in ${activeMethod.LastFour}</span>`)
                $("#PaymentMethodHeader").html(`By selecting "Enroll", you are authorizing CURE Auto Insurance to store and use the specified card for future payments.`)
                $("#PaymentMethodInfo").html(`* By choosing this card as your payment method, you are authorizing CURE Auto Insurance to utilize this card to initiate one or more debits for the specified amount(s) to your card. This authorization shall remain in effect until you notify CURE Auto Insurance of its termination in such a manner as to afford CURE Auto Insurance a reasonable opportunity to act on it by telephone at 800-535-2873. Any changes to this consent will be communicated to you by CURE Auto Insurance.`)
            }

            $("#ConfirmationDiv").fadeIn(300);
        }
    const HandleConfirmation = async (pol,env) =>{
        //console.log(actionType);
        if(actionType == "enroll"){
            EnrollAutopay(pol,env);
        }

        if(actionType == "update"){
            UpdateAutopay(pol,env);
        }
    }

    const EnrollAutopay = async (Pol, Env) => {
        console.log("Enrolling in autopay...")
        // const payment = await GetPaymentData(Pol, Zip, Env)
        const CustomerName = (payment.PolState === "PA" ? payment.FullName : payment.FirstName + " " + (payment.MiddleInitial != null && payment.MiddleInitial.length > 0 ? payment.MiddleInitial + " " : "") + payment.LastName);
        const PayMethodTokenId = $('input[name="PaymentMethod"]:checked').val();
        const AmountPerInstallment = payment.Amt
        const activeMethod = paymentMethods.filter(x=>x.ProcessOneToken === PayMethodTokenId)[0];
        const enrollautopay_resp = await enrollAutoPay(Pol, PayMethodTokenId, payment.CustomerID, CustomerName, payment.Email, payment.DueDate, AmountPerInstallment, Env, source)
        if (enrollautopay_resp) {
            if (enrollautopay_resp.response === true) {
                $("#result").html("YOU'RE NOW ENROLLED IN AUTOPAY");
                $("#description").html("You can review and make changes to your policy's pay plan by clicking Edit AutoPay");
                updateAutopayCompleted()
            } else {
                $("#result").html("WE COULDN'T APPLY YOUR CHANGES");
                $("#description").html("Please contact us to apply the changes to the installment plan");
            }
            $("#divCloseCUREmodal").fadeIn(300);

            $("#ConfirmationDiv").css("display", "none");
            $("#successDiv").fadeIn(300);
        }
    }

    const UpdateAutopay = async (Pol, Env) => {
        console.log("Updating autopay...")
        const PayMethodTokenId = $('input[name="PaymentMethod"]:checked').val();
        const updateautopay_resp = await updateAutoPay(Pol, PayMethodTokenId, Env)
        if (updateautopay_resp) {
            if (updateautopay_resp.response) {
                $("#result").html("YOUR CHANGES WERE ADDED<br />TO AUTOPAY");
                $("#description").html("You can review and make changes to your policy's pay plan by clicking Edit AutoPay");
                updateAutopayCompleted()
            } else {
                $("#result").html("WE COULDN'T APPLY YOUR CHANGES");
                $("#description").html("Please contact us to apply the changes to the installment plan");
            }
            $("#divCloseCUREmodal").fadeIn(300);
            $("#ConfirmationDiv").css("display", "none");
            $("#successDiv").fadeIn(300);
        }
    }
    const CancelAutopay = async (Pol, Env) => {
        console.log("Canceling autopay...")
        const cancelautopay_resp = await cancelAutoPay(Pol, Env, source)
        if (cancelautopay_resp) {
            if (cancelautopay_resp.response) {
                $("#formDiv").css("display", "none");
                $("#result").html("AUTOPAY SUCCESSFULLY CANCELLED");
                $("#description").html("You can enroll again in Autopay by clicking Enroll AutoPay in My Account");
                updateAutoPay()
            } else {
                $("#result").html("WE COULDN'T APPLY YOUR CHANGES");
                $("#description").html("Please contact us to apply the changes to the installment plan");
            }
            $("#divCloseCUREmodal").fadeIn(300);
            $("#successDiv").fadeIn(300);
        }
    }

    async function ManagePaymentMethods() {
        setAutoPayReady(false)
        setIsLoading(true)
        setShow(false)
        autopayManagePayMethods.current = true
        managePaymentMethods(payment, sessionID);
    }
    $('input[type=radio][name=PaymentMethod]').change(function () {
        setIsEnrollAutopayDisabled(false)
        setIsUpdateAutopayDisabled(false)
    });
    if (autoPayReady) {
        return (
            show && (pol !== "" && zip !== "" && env !== "" && isAutopay) &&
            <>
                <div className="modal fade show" style={{ display: "block" }} id="Autopaymodal" tabIndex="-1" aria-labelledby="AutopaymodalLabel">
                    <div className="modal-dialog modal-dialog-centered modal-lg">
                        <div className="modal-content" style={{ borderTop: "6px solid #1c70a8", width: "80%", marginLeft: "10%" }}>
                            <div className="modal-header">
                                <img src={Images.portalOne.cureLogo} style={{ height: "45px" }} />
                                <button id="AutopaymodalCloseBtn" type="button" style={{ fontSize: "16px", fontWeight: "normal", color: "#478cbc", paddingRight: "40px", backgroundColor: "transparent", border: "none", opacity: "0.5", marginTop: "0px" }}
                                    className="close" data-dismiss="modal" aria-label="Close" onClick={() => setShow(false)}>
                                    <span aria-hidden="true">CLOSE</span>
                                </button>
                            </div>
                            <div className="modal-body">
                                <div className="container-fluid" id="AutopaymodalContainer">
                                    <div className="col-sm-12" id="formDiv">
                                        {isAutopayEnrolled ? <>
                                            <h6 className="blue-font text-left">CURRENT PAYMENT METHOD</h6>
                                            <table>
                                                <tbody>
                                                    <tr>
                                                        <td>
                                                            <img style={{ height: "37px" }} src={Images.portalOne.paymentMethod.hasOwnProperty(activeMethod.CreditCardType) ? Images.portalOne.paymentMethod[activeMethod.CreditCardType] : Images.portalOne.paymentMethod.Other}
                                                                alt={Images.portalOne.paymentMethodAlt.hasOwnProperty(activeMethod.CreditCardType) ? Images.portalOne.paymentMethodAlt[activeMethod.CreditCardType] : Images.portalOne.paymentMethodAlt.Other} />
                                                        </td>
                                                        <td>
                                                            <label style={{ lineHeight: "1.3", margin: "10px 0px 10px 15px" }}>
                                                                {activeMethod.PaymentMethodType === "Eft" ? <>
                                                                    {activeMethod.BankName} {activeMethod.BankAccountType} <br />ending in {activeMethod.LastFour}
                                                                </> : <>
                                                                    {activeMethod.CreditCardType} ending in {activeMethod.LastFour}<br />
                                                                    Expires {activeMethod.CardExpirationMonth.toString()}/{activeMethod.CardExpirationYear % 100}
                                                                </>}
                                                            </label>
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                            <br />
                                            <h6 className="blue-font text-left" style={{ marginBottom: "20px" }} >CHANGE PAYMENT METHOD</h6>
                                        </> : <>
                                            <br />
                                            <h5 className="blue-font text-left">SELECT PAYMENT METHOD</h5>
                                            <br />
                                        </>}
                                        <div className="text-center" id="PaymentMethods">
                                            {paymentMethods.map((method) => {
                                                if (!isAutopayEnrolled || method.ProcessOneToken !== activeMethod.ProcessOneToken) {
                                                    return <div key={method.ProcessOneToken}>
                                                        <div className="grey-font rounded" style={{ width: "80%", backgroundColor: "transparent", border: "1px solid #d0d2d3", margin: "5px 0px 5px 10%" }}>
                                                            <table>
                                                                <tbody>
                                                                    <tr>
                                                                        <td className="text-center">
                                                                            <input onClick={() => { setIsEnrollAutopayDisabled(false); setIsUpdateAutopayDisabled(false) }} type="radio" id={method.PaymentMethodId} value={method.ProcessOneToken} name="PaymentMethod"
                                                                                style={{ transform: "scale(1.7", border: "1px solid #d0d2d3", margin: "0px 15px 0px 18px" }}
                                                                            /><br />
                                                                        </td>
                                                                        <td className="text-center">
                                                                            <img style={{ height: "37px" }} src={Images.portalOne.paymentMethod.hasOwnProperty(method.CreditCardType) ? Images.portalOne.paymentMethod[method.CreditCardType] : Images.portalOne.paymentMethod.Other}
                                                                                alt={Images.portalOne.paymentMethodAlt.hasOwnProperty(method.CreditCardType) ? Images.portalOne.paymentMethodAlt[method.CreditCardType] : Images.portalOne.paymentMethodAlt.Other} />
                                                                        </td>
                                                                        <td className="text-left">
                                                                            <label htmlFor={method.PaymentMethodId} style={{ lineHeight: "1.3", fontSize: "14.5px", margin: "10px 0px 10px 15px", textAlign: "left" }}>
                                                                                {method.PaymentMethodType === "Eft" ? <>
                                                                                    {method.BankName} {method.BankAccountType} <br />ending in {method.LastFour}

                                                                                </> : <>
                                                                                    {method.CreditCardType} ending in {method.LastFour}<br />
                                                                                    Expires {method.CardExpirationMonth.toString()}/{method.CardExpirationYear % 100}

                                                                                </>}
                                                                            </label>
                                                                        </td>
                                                                    </tr>
                                                                </tbody>
                                                            </table>
                                                        </div>
                                                    </div>
                                                }
                                            })}
                                            <div id="ManagePaymentMethods" className="text-left" style={{ width: "80%", height: "60px", marginLeft: "10%", paddingTop: "10px", display: "flex" }}>
                                                <span className="grey-font" style={{ fontSize: "30px", lineHeight: "20px", fontWeight: "100" }}>+</span>
                                                <a onClick={() => ManagePaymentMethods()} style={{ color: "#349c9c", fontWeight: "bolder" }}>ADD OR MANAGE PAYMENT METHODS</a>
                                            </div>
                                        </div>
                                        <br />
                                        <div className="text-center" id="submitDiv" style={{ display: "flex", justifyContent: "flex-start", alignItems: "center", flexWrap: "wrap", justifyContent: "center" }}>
                                            {isAutopayEnrolled ? <>
                                                <button id="AutopayUnenrollBtn" type="button" style={{ width: "40%", backgroundColor: "#206cac", color: "white", border: "none", padding: "10px 0px 10px 0px", margin: "8px", borderRadius: "0.25rem" }}
                                                    onClick={() => CancelAutopay(pol, env)}>
                                                    STOP AUTOPAY
                                                </button>
                                                <button disabled={isUpdateAutopayDisabled} id="AutopayUpdateBtn" type="button" className="autopaybtn" style={{ width: "40%", backgroundColor: "#206cac", color: "white", border: "none", padding: "10px 0px 10px 0px", margin: "8px", borderRadius: "0.25rem" }}
                                                    onClick={() => {actionType = "update"; ShowConfirmation(pol, zip, env)}}>
                                                    UPDATE AUTOPAY
                                                </button>
                                            </> : <>
                                                <button disabled={isEnrollAutopayDisabled} id="AutopayEnrollBtn" className="autopaybtn" style={{ width: "80%", backgroundColor: "#206cac", border: "none", padding: "10px 0px 10px 0px", marginBottom: "8px", color: "white", borderRadius: "0.25rem" }}
                                                    onClick={() => {actionType = "enroll";  ShowConfirmation(pol, zip, env) }}>
                                                    ENROLL IN AUTOPAY
                                                </button>
                                            </>}
                                            <button onClick={() => setShow(false)} id="AutopayCancelBtn" type="button" style={{ width: "30%", backgroundColor: "transparent", border: "1px solid", padding: "10px 0px 10px 0px" }}
                                                className="btn" data-dismiss="modal">
                                                CANCEL
                                            </button>
                                        </div>
                                        <br />
                                    </div>

                                    <div className="col-sm-12 text-center" id="ConfirmationDiv" style={{ display: "none" }}>
                                        <br />
                                        <h5 className="blue-font" style={{textAlign:'left'}}>CONFIRM AUTOPAY ENROLLMENT</h5>
                                        <div id="PaymentMethodHeader" style={{ fontWeight: "bold",fontSize:'1em', textAlign:'left', marginTop:'1em'  }}></div>
                                        <br />
                                        <div>
                                            <div id="PaymentMethodRow" style={{display:'flex', justifyContent:'space-around', marginTop:'1em', marginBottom:'2em'}}>

                                            </div>
                                            <div id="PaymentMethodInfo" style={{ textAlign:'left', marginTop:'1em'  }}></div>
                                            <h6 style={{fontWeight:'bold', fontSize:'1em',textAlign:'left', marginTop:'2em'  }}>Please note: Your Autopay payment will be withdrawn the day prior to your bill due date.</h6>
                                        </div>
                                        <br />
                                        <button disabled={isEnrollAutopayDisabled} id="AutopayEnrollBtn2" className="autopaybtn" style={{ width: "80%", backgroundColor: "#206cac", border: "none", padding: "10px 0px 10px 0px", marginBottom: "8px", color: "white", borderRadius: "0.25rem" }}
                                                    onClick={() => { HandleConfirmation(pol, env) }}>
                                                  ENROLL  
                                        </button>
                                        <br />
                                        <button onClick={() => {$("#ConfirmationDiv").css("display", "none");$("#formDiv").fadeIn(300); }} id="AutopayCancelBtn" type="button" style={{ width: "30%", backgroundColor: "transparent", border: "1px solid", padding: "10px 0px 10px 0px" }}
                                                className="btn" data-dismiss="modal">
                                                MAKE CHANGES
                                        </button>
                                    </div>

                                    <div className="col-sm-12 text-center" id="successDiv" style={{ display: "none" }}>
                                        <br />
                                        <br />
                                        <div>
                                            <h4 id="result"></h4>
                                            <h6 id="description" style={{ fontWidth: "500" }}></h6>
                                        </div>
                                        <br />
                                        <br />
                                        <br />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="modal-backdrop fade show"></div>
            </>
        )
    } else {
        return (
            show &&
            <>
                < Loading showText={true} />
            </>
        )
    }
}

export default AutoPayModal